// const AnimatedSection = () => {
// 	useEffect(() => {
// 		const ScrollTriggerSettings = {
// 			trigger: mainRef.current,
// 			start: "top 25%",
// 			toggleActions: "play reverse play reverse",
// 		};
// 		const leftXValues = [-800, -900, -400];
// 		const rightXValues = [800, 900, 400];
// 		const leftRotationValues = [-30, -20, -35];
// 		const rightRotationValues = [30, 20, 35];
// 		const yValues = [100, -150, -400];

// import { CarouselItem } from "@/components/LandingPage/Carousel/Carousel";

// 		gsap.utils.toArray(`${styles.main}`).forEach((row: any, index: number) => {
// 			const cardLeft = row.querySelector(`${styles.card_left}`);
// 			const cardRight = row.querySelector(`${styles.card_right}`);
// 			// const cardLeft = cardLeftRef.current;
// 			// const cardRight = cardRightRef.current;

// 			gsap.to(cardLeft, {
// 				x: leftXValues[index],
// 				scrollTrigger: {
// 					trigger: mainRef.current,
// 					start: "top center",
// 					end: "150% bottom",
// 					scrub: true,
// 					onUpdate: (self: any) => {
// 						const progress = self.progress;
// 						if (cardLeft) {
// 							cardLeft.style.transform = `translateX(${
// 								progress * leftXValues[index]
// 							}px)
// 							translateY(${progress * yValues[index]}px) rotate(${
// 								progress * leftRotationValues[index]
// 							}deg)`;
// 						}
// 						// if (cardRight) {
// 						// 	cardRight.style.transform = `translateX(${
// 						// 		progress * rightXValues[index]
// 						// 	}px)
// 						// 	translateY(${progress * yValues[index]}px) rotate(${
// 						// 		progress * rightRotationValues[index]
// 						// 	}deg)`;
// 						// }
// 					},
// 				},
// 			});
// 			gsap.to(cardRight, {
// 				x: leftXValues[index],
// 				scrollTrigger: {
// 					trigger: mainRef.current,
// 					start: "top center",
// 					end: "150% bottom",
// 					scrub: true,
// 					onUpdate: (self: any) => {
// 						const progress = self.progress;
// 						// if (cardLeft) {
// 						// 	cardLeft.style.transform = `translateX(${
// 						// 		progress * leftXValues[index]
// 						// 	}px)
// 						// 	translateY(${progress * yValues[index]}px) rotate(${
// 						// 		progress * leftRotationValues[index]
// 						// 	}deg)`;
// 						// }
// 						if (cardRight) {
// 							cardRight.style.transform = `translateX(${
// 								progress * rightXValues[index]
// 							}px)
// 							translateY(${progress * yValues[index]}px) rotate(${
// 								progress * rightRotationValues[index]
// 							}deg)`;
// 						}
// 					},
// 				},
// 			});
// 		});
// 	});

export const firstSlider: any[] = [
	{ type: "text", value: "weddings" },
	{ type: "image", value: "/images/weddings.png" },
	{ type: "text", value: "birthdays" },
	{ type: "image", value: "/images/birthdays.png" },
	{ type: "text", value: "concerts & festivals" },
	{ type: "image", value: "/images/concerts_and_festivals.png" },
	{ type: "text", value: "weddings" },
	{ type: "image", value: "/images/weddings.png" },
	{ type: "text", value: "birthdays" },
	{ type: "image", value: "/images/birthdays.png" },
	{ type: "text", value: "concerts & festivals" },
	{ type: "image", value: "/images/concerts_and_festivals.png" },
];

export const secondSlider: any[] = [
	{ type: "text", value: "seminars" },
	{ type: "image", value: "/images/seminars.png" },
	{ type: "text", value: "church events" },
	{ type: "image", value: "/images/church_events.png" },
	{ type: "text", value: "school function" },
	{ type: "image", value: "/images/school_events.png" },
	{ type: "text", value: "seminars" },
	{ type: "image", value: "/images/seminars.png" },
	{ type: "text", value: "church events" },
	{ type: "image", value: "/images/church_events.png" },
	{ type: "text", value: "school function" },
	{ type: "image", value: "/images/school_events.png" },
];
